import React from "react";
import { Spinner } from "react-bootstrap";

const LoadingButton = () => {
  return <Spinner as="span" animation="border" size="sm" className="me-1" />;
};

export default LoadingButton;
